var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('prices'),_c('get-account-state'),_c('get-eth-tx-for-withdraw')],1)}
var staticRenderFns = []

export { render, staticRenderFns }